/* eslint-disable no-case-declarations */
/* eslint-disable prefer-const */
import { useState, useMemo } from 'react';
import {
  orderBy, filter as filterBy, partition,
} from 'lodash';
import dayjs from 'dayjs';
import TrieSearch from 'trie-search/src/TrieSearch';
import useProductCollection from './useProductCollection';

const formatProduct = ({
  title,
  media: shopifyFeaturedMedia,
  tags,
  handle,
  deadline,
  deadline_time,
  media: featuredMedia,
  preview_image,
  charities = [],
  start,
  type,
}) => {
  let url;
  switch (type) {
    case 'SWEEPSTAKES':
      url = `/sweeps/${handle}`;
      break;
    case 'AUCTION':
      url = `/auctions/${handle}`;
      break;
    case 'FANDM':
      url = `/fandms/${handle}`;
      break;
    case 'NFT':
      url = `/nfts/${handle}`;
      break;
    default:
      url = `/products/${handle}`;
      break;
  }

  return {
    type,
    handle,
    title,
    media: preview_image || featuredMedia || shopifyFeaturedMedia,
    image: preview_image || featuredMedia || shopifyFeaturedMedia,
    deadline,
    deadline_time,
    start: dayjs(start),
    end: dayjs(`${deadline} ${deadline_time} +0000`),
    tags,
    charities,
    url,
  };
};

export default function useCollectionFilters({
  productType = 'all',
  collectionHandle = 'all',
  initialOrder = 'newest',
  initialFilter = '',
  limit = null,
  excludeTags = [],
}) {
  const products = useProductCollection(collectionHandle, [], 'exclude marketplace');

  const tagFilteredProducts = products.filter((prod) => (
    !excludeTags.some((tag) => prod.tags.includes(tag))
  ));


  const totalProducts = tagFilteredProducts?.length || 0;
  // const urlParts = window.location.pathname.split('/');
  // const productType = urlParts[urlParts.length - 1];
  const [type, setType] = useState(productType);
  let productTypeFilter = tagFilteredProducts;

  let sweeps = tagFilteredProducts.filter((prod) => prod.type === 'SWEEPSTAKES');
  let auctions = tagFilteredProducts.filter((prod) => prod.type === 'AUCTION');
  let fandms = tagFilteredProducts.filter((prod) => prod.type === 'FANDM');
  let nfts = tagFilteredProducts.filter((prod) => prod.type === 'NFT');
  if (productTypeFilter) {
    switch (type) {
      case 'SWEEPS':
        productTypeFilter = sweeps;
        break;
      case 'AUCTION':
        productTypeFilter = auctions;
        break;
      case 'FANDM':
        productTypeFilter = fandms;
        break;
      case 'NFT':
        productTypeFilter = nfts;
        break;
      default:
    }
  }

  const [filter, setFilter] = useState(initialFilter);
  const [order, setOrder] = useState(initialOrder);
  const productTrie = useMemo(() => {
    const ts = new TrieSearch(['title']);
    if (productTypeFilter) {
      ts.addAll(productTypeFilter);
    }
    return ts;
  }, [productTypeFilter]);

  function orderTrending(prods) {
    return orderBy(
      prods,
      (product) => {
        const { deadline, deadline_time } = product;
        let isOver = false;
        if (deadline && deadline_time && deadline !== 'Invalid Date' && deadline_time !== 'Invalid Date') {
          const date = dayjs(`${deadline} ${deadline_time} +0000`);
          const now = dayjs();
          isOver = date.isBefore(now);
        }
        return isOver;
      }, // pin expired contests to the bottom of the list
    ); // The 'all' collection sorts by best selling by default.
  }

  function getProducts() {
    const filteredProducts = filter ? productTrie.get(filter) : productTypeFilter;
    console.log('filteredProducts', filteredProducts);

    let orderedProducts;
    switch (order) {
      case 'ending_soon':
        orderedProducts = filterBy(
          filteredProducts,
          (product) => product.deadline && product.deadline_time,
        );
        orderedProducts = orderBy(
          orderedProducts,
          (product) => dayjs(`${product.deadline} ${product.deadline_time} +0000`),
          ['asc'],
        );
        let [ended, active] = partition(orderedProducts, (product) => {
          const { deadline, deadline_time } = product;
          let isOver = false;
          if (deadline && deadline_time) {
            const date = dayjs(`${deadline} ${deadline_time} +0000`);
            const now = dayjs();
            isOver = date.isBefore(now);
          }
          return isOver;
        });
        ended = orderBy(
          ended,
          (product) => dayjs(`${product.deadline} ${product.deadline_time} +0000`),
          ['desc'],
        );
        return [...active, ...ended];
      case 'oldest':
        orderedProducts = orderBy(
          filteredProducts,
          (product) => product.publishedAt,
          ['asc'],
        );
        return orderBy(
          orderedProducts,
          (product) => {
            const { deadline, deadline_time } = product;
            let isOver = false;
            if (deadline && deadline_time && deadline !== 'Invalid Date' && deadline_time !== 'Invalid Date') {
              const date = dayjs(`${deadline} ${deadline_time} +0000`);
              const now = dayjs();
              isOver = date.isBefore(now);
            }
            return isOver;
          },
        );
      case 'trending':
        return orderTrending(filteredProducts);
      default:
        orderedProducts = orderBy(
          filteredProducts,
          (product) => product.publishedAt,
          ['desc'],
        );
        return orderBy(
          orderedProducts,
          (product) => {
            const { deadline, deadline_time } = product;
            let isOver = false;
            if (deadline && deadline_time && deadline !== 'Invalid Date' && deadline_time !== 'Invalid Date') {
              const date = dayjs(`${deadline} ${deadline_time} +0000`);
              const now = dayjs();
              isOver = date.isBefore(now);
            }
            return isOver;
          },
        );
    }
  }

  function handleOrder(e, value) {
    setOrder(value);
  }

  function handleFilter(e) {
    setFilter(e.target.value);
  }
  let experiences = getProducts().map(formatProduct);
  sweeps = sweeps.map(formatProduct);
  nfts = nfts.map(formatProduct);
  auctions = auctions.map(formatProduct);
  fandms = fandms.map(formatProduct);

  let bestSelling;

  if (productTypeFilter && productTypeFilter.length) {
    const product = orderTrending(productTypeFilter)[0];
    bestSelling = formatProduct(product);
  }

  if (limit) {
    experiences = experiences.slice(0, limit);
  }

  return {
    handleOrder,
    handleFilter,
    totalProducts,
    filter,
    order,
    experiences,
    unfilteredProducts: products,
    bestSelling,
    type,
    setType,
    sweeps,
    nfts,
    auctions,
    fandms,
  };
}
